<template>
  <div :class="['hero', '--theme-' + theme]">
    <div class="pp-container">
      <header class="hero__header">
        <a href="#" class="hero__logo"><img src="@/assets/images/logo-w.svg" alt="Componata"> <span>Für Ihr Unternehmen</span></a>

        <nav class="hero__nav visible-lg">
          <ul class="hero__nav-list">
            <!-- <li class="hero__nav-item"><a href="#">The Present</a></li>
            <li class="hero__nav-item"><a href="#">The Products</a></li>
            <li class="hero__nav-item"><a href="#">The Postcard</a></li>
            <li class="hero__nav-item"><a href="#">The Box</a></li> -->
            <li class="hero__nav-item --is-phone"><i class="icon icon-phone"></i> 0341 9899 2081</li>
          </ul>
        </nav>
      </header>

      <div class="hero__content">
        <div class="row middle-xs">
          <div class="kol-xs-12 kol-md-6">
            <h5 class="hero__epigraph">{{epigraph}}</h5>
            <h1 class="hero__title">{{title}}</h1>
            <p class="hero__description" v-html="description"></p>

            <div class="hero__cta">
              <Button type="button" appearance="special" v-on:click="scrollTo('products')">{{ button }}</Button>
              <Price :price="price" :secondLine="secondLine" />
            </div>
          </div>

          <div class="kol-xs-12 kol-md-6">
            <div class="hero__photo">
              <img
                v-if="image"
                class="hero__product-photo --is-level1"
                :srcset="`
                  ${image['1536x1536']}?format=${webPFormat('png')}&width=1500&nearlossless=1&quality=80 2x,
                  ${image['1536x1536']}?format=${webPFormat('png')}&width=800&nearlossless=1&quality=80 1x
                `"
                :src="`${image['1536x1536']}?format=${webPFormat('png')}&width=800&nearlossless=1&quality=80`"
                data-aos="fade-left"
                data-aos-delay="400"
              >

              <img
                v-else
                class="hero__product-photo"
                :srcset="`
                  ${require('@/assets/images/proposal-page/box-packaging@2x.png')}?format=${webPFormat('png')}&width=1600&nearlossless=1&quality=80 2x,
                  ${require('@/assets/images/proposal-page/box-packaging@2x.png')}?format=${webPFormat('png')}&width=800&nearlossless=1&quality=80 1x
                `"
                :src="`${require('@/assets/images/proposal-page/box-packaging@2x.png')}?format=${webPFormat('png')}&width=800&nearlossless=1&quality=80`"
                data-aos="fade-left"
                data-aos-delay="400"
              >

              <div class="hero__postcard">
                <img
                  :src="postcardImage"
                  data-aos="fade-left"
                  data-aos-delay="600"
                >

                <img
                  :srcset="`
                    ${require('@/assets/images/proposal-page/handwriting@2x.png')}?format=${webPFormat('png')}&width=690&nearlossless=1&quality=80 2x,
                    ${require('@/assets/images/proposal-page/handwriting@2x.png')}?format=${webPFormat('png')}&width=345&nearlossless=1&quality=80 1x
                  `"
                  :src="`${require('@/assets/images/proposal-page/handwriting@2x.png')}?format=${webPFormat('png')}&width=345&nearlossless=1&quality=80`"
                  data-aos="fade-left"
                  data-aos-delay="600"
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { helperMixin } from '@/mixins/HelperMixin';

import Button from '@/components/proposal-page/Button';
import Price from '@/components/proposal-page/Price';

export default {
  name: 'Hero',
  mixins: [helperMixin],
  components: {
    Button,
    Price
  },
  props: {
    theme: {
      type: String,
      default: 'light-pink'
    },
    epigraph: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    price: {
      type: String,
      default: null
    },
    image: {
      type: String,
      default: null
    },
    postcardImage: {
      type: String,
      default: null
    },
    button: {
      type: String,
      default: null
    },
    secondLine: {
      type: String,
      default: null
    }
  },
  methods: {
    scrollTo: function (id) {
      document.getElementById(id).scrollIntoView({
        behavior: 'smooth'
      });
    }
  }
};
</script>

<style lang="scss" scoped>
/**
 * Hero
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Hero, header included. This handles the different themes and styles for the component.
 * @since 2020-10-26
**/

$component: 'hero';

.#{$component} {
  position: relative;
  overflow: hidden;
  @include margin-bottom(map-get($spacers, 4));
  @include padding-bottom(map-get($spacers, 4) * 3);
  // background:
  //   url('~@/assets/images/landing-page/bgr-confetti.svg') center top no-repeat,
  //   linear-gradient(to bottom, $main-color 83%, desaturate(darken($main-color, 10%), 30%));
  background-size: contain;
  z-index: 0;

  // Rounded bottom
  &:before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 200px;
    border-bottom: 80px solid $white;
    background: url('~@/assets/images/landing-page/hero-rounded-bottom.svg') center top no-repeat;
    background-size: cover;
    pointer-events: none;
  }

  // White flare on top of bg
  &:after {
    content: '';
    position: absolute;
    width: 40%;
    height: 985px;
    left: 30%;
    top: -213.7px;
    // background: linear-gradient(279.86deg, rgba(255, 255, 255, 0) 15.58%, rgba(255, 255, 255, 0.0515625) 38.3%, rgba(255, 230, 0, 0) 60.37%);
    opacity: 1;
    transform: rotate(18.03deg);
    z-index: -1;
  }

  & > .pp-container {
    // height: 600px;
  }

  // Header
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    z-index: 1;
    @include margin-bottom(map-get($spacers, 4) * 5);
    @include padding-top(map-get($spacers, 4));
    @include padding-bottom(map-get($spacers, 4));

    ::v-deep .btn {
      font-weight: $font-weight-bold;
    }
  }

  // Logo
  &__logo {
    display: flex;
    align-items: center;
    color: darken($white, 50%);

    img {
      display: block;
    }

    span {
      display: inline-block;
      margin-top: 10px;
      margin-left: 14px;
      font-size: map-get($proposal-page, 'font-size-sm');
      font-weight: $font-weight-light;
    }
  }

  // Nav
  &__nav {
    text-align: right;
  }

  &__nav-list {
    @include unlist;

    display: flex;
    align-items: center;
  }

  &__nav-item {
    font-weight: 300;

    &:not(:first-child) {
      margin-left: map-get($spacers, 5);
    }

    &.--is-phone .icon {
      vertical-align: middle;
      margin-right: 2px;
      font-size: map-get($proposal-page, 'font-size-xl');
    }
  }

  // Content
  &__content {
    position: static;
    z-index: 0;
    // overflow: hidden;
    @include margin-top(- map-get($spacers, 6));
  }

  &__epigraph {
    @include font-size(1.380rem);
    font-family: 'Frank Ruhl Libre';
    font-weight: 300;
    // @extend %text-glow;
  }

  &__title {
    @include margin-bottom(map-get($spacers, 4));
    @include font-size(3.6rem);
    line-height: 110%;
    font-family: 'Frank Ruhl Libre';
    font-weight: 300;
    margin-left: auto;
    margin-right: auto;
  }

  &__description {
    @include font-size(map-get($proposal-page, 'font-size-lg'));
    line-height: 170%;
    font-weight: 200;
    margin-left: auto;
    margin-right: auto;
  }

  &__cta {
    display: flex;
    @include margin-top(map-get($spacers, 6));

    ::v-deep .btn {
      font-weight: $font-weight-bold;
      @include margin-right(map-get($spacers, 4));
    }
  }

  &__photo {
    position: relative;
    // max-height: 422.53px;
    width: 100%;
    @include rfs(translateX(map-get($spacers, 5)), transform);
    z-index: 0;
    pointer-events: none;
  }

  &__product-photo {
    display: flex;
    @include imageRendering;
    max-width: unset !important;
    width: 800px;
    margin-top: -80px;
    margin-bottom: -50px;
    margin-left: -100px;

    &.--is-level1 {
      width: 100%;
      margin-left: -50px;
    }
  }

  &__postcard {
    position: absolute;
    bottom: -120px;
    left: 260px;
    width: 100%;

    img {
      @include imageRendering;
    }

    img:nth-child(1) {
      width: 220px;
      transform: rotate(-15deg) !important;
      margin-top: -130px;
      margin-right: -80px;
    }

    img:nth-child(2) {
      width: 400px;
      transform: rotate(10deg) !important;
    }
  }

  // ——————————————————————————————
  // Themes
  // ——————————————————————————————

  // Light Pink
  &.--theme-black {
    $main-color: #111111;

    // background:
    // url('~@/assets/images/landing-page/bgr-confetti.svg') center top no-repeat,
    // linear-gradient(to bottom, $main-color 70%, desaturate(darken($main-color, 10%), 30%));
    background-color: $main-color;
    color: #ececec;

    &:before {
      display: none;
    }

    &:after {
      background: linear-gradient(90deg, rgba(255, 255, 255, 0) 15%, rgba(255, 230, 0, 0.037) 34.73%, rgba(255, 255, 255, 0.044) 45%, rgba(255, 255, 255, 0) 70%);
      opacity: 0.7;
    }

    .#{$component} {
      // Nav
      &__nav-item,
      &__nav-item a {
        color: $gray-ghost-fixed;
      }

      &__nav-item.--is-phone {
        color: $white;
        font-weight: $font-weight-bold;
      }

      // Content
      &__epigraph,
      &__title,
      &__description {
        text-shadow: 0 0 15px $main-color, 0 0 15px $main-color, 0 0 15px $main-color, 0 0 15px $main-color, 0 0 15px $main-color;
      }
    }
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($proposal-page, 'viewport-lg')) {
    &__logo {
      display: block;
      margin-left: auto;
      margin-right: auto;

      span {
        display: block;
        margin: 10px 0 0 0;
      }
    }

    &__photo {

    }

    &__postcard {
      width: 200%;
      left: 50px;
    }
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($proposal-page, 'viewport-md')) {
    @include padding-bottom(map-get($spacers, 5) * 3);
    box-shadow: 7px 9px 14px 3px rgba(0, 0, 0, 0.05);

    &__photo {
      width: 70%;
      @include margin-top(map-get($spacers, 6));
      margin-left: auto;
      margin-right: auto;
      @include margin-bottom(map-get($spacers, 4) * 6);
      transform: translateX(0);

      ::v-deep .postcard-thumbnails {
        width: 50%;
        bottom: -20%;
        margin-left: auto;
        margin-right: auto;
        left: 0;
        right: 0;
      }
    }

    &__product-photo {
      width: 700px;
      margin-left: 0;

      &.--is-level1 {
        width: 80%;
        margin-top: 0;
        margin-left: auto;
        margin-right: auto;
      }
    }

    &__postcard {
      left: -45%;
      bottom: -220px;
      transform: scale(0.7);
    }

    &__content {
      text-align: center;
    }

    &__title,
    &__description {
      width: 80%;
    }

    &__cta {
      position: absolute;
      bottom: 0;
      width: 100%;
      flex-direction: row-reverse;
      justify-content: space-between;
      margin-left: -1em;
      margin-right: -1em;
      @include padding(map-get($spacers, 4));
      background-color: $white;
      color: $ink;

      ::v-deep .btn {
        margin-right: 0;
      }
    }
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($proposal-page, 'viewport-sm')) {
    &__title,
    &__description {
      width: 100%;
    }

    &__photo {
      width: 90%;
      transform: translateX(0);
      margin-left: auto;
    }

    &__postcard {
      left: -40%;
    }
  }

  // ——————————————————————————————
  // XXS
  // ——————————————————————————————
  @media (max-width: map-get($proposal-page, 'viewport-xs')) {
    &__content {

    }

    &__photo {
      @include margin-bottom(map-get($spacers, 4) * 10);

      ::v-deep .postcard-thumbnails {
        left: unset;
        right: 0;
      }
    }

    &__product-photo {
      &.--is-level1 {
        @include margin-bottom(map-get($spacers, 4) * 15);
      }
    }

    &__cta {
      @include margin-bottom(- map-get($spacers, 4));
      flex-flow: column;
      flex-direction: column-reverse;

      ::v-deep .price {
        @include margin-bottom(map-get($spacers, 4));
      }
    }
  }

  // ——————————————————————————————
  // XS
  // ——————————————————————————————
  @media (min-width: map-get($proposal-page, 'viewport-xs')) and (max-width: map-get($proposal-page, 'viewport-sm')) {
  }

  // ——————————————————————————————
  // SM
  // ——————————————————————————————
  @media (min-width: map-get($proposal-page, 'viewport-sm')) and (max-width: map-get($proposal-page, 'viewport-md')) {
  }

  // ——————————————————————————————
  // MD
  // ——————————————————————————————
  @media (min-width: map-get($proposal-page, 'viewport-md')) and (max-width: map-get($proposal-page, 'viewport-lg')) {
  }
}
</style>
